import { render, staticRenderFns } from "./quesDistribution.vue?vue&type=template&id=67732cba&"
import script from "./quesDistribution.vue?vue&type=script&lang=js&"
export * from "./quesDistribution.vue?vue&type=script&lang=js&"
import style0 from "./quesDistribution.vue?vue&type=style&index=0&id=67732cba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports